module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui segments"
  }, [_c('div', {
    staticClass: "ui clearing segment"
  }, [_c('div', {
    staticClass: "ui breadcrumb mw-breadcrumb stackable equal width compact"
  }, [_c('router-link', {
    staticClass: "section",
    attrs: {
      "to": {
        name: 'goods'
      }
    }
  }, [_vm._v("\n          Preces\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "divider"
  }, [_vm._v("/")]), _vm._v(" "), (_vm.item.categoryA) ? _c('router-link', {
    staticClass: "section",
    attrs: {
      "to": {
        name: 'goods'
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.item.categoryA) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "divider"
  }, [_vm._v("/")]), _vm._v(" "), (_vm.item.categoryB) ? _c('router-link', {
    staticClass: "section",
    attrs: {
      "to": {
        name: 'goods'
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.item.categoryB) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "divider"
  }, [_vm._v("/")]), _vm._v(" "), (_vm.item.categoryC) ? _c('router-link', {
    staticClass: "section",
    attrs: {
      "to": {
        name: 'goods'
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.item.categoryC) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.item.categoryC) ? _c('span', {
    staticClass: "divider"
  }, [_vm._v("/")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "active section"
  }, [_vm._v(_vm._s(_vm.item.goods_name))])], 1), _vm._v(" "), _c('good-card', {
    key: _vm.rerenderKey,
    staticClass: "ui segment good-card-segment"
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9f5178e0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GoodPage/GoodPage.vue
// module id = 364
// module chunks = 1